import { render, staticRenderFns } from "./EditSaleRegion.vue?vue&type=template&id=dc1b563a&"
import script from "./EditSaleRegion.vue?vue&type=script&lang=js&"
export * from "./EditSaleRegion.vue?vue&type=script&lang=js&"
import style0 from "./EditSaleRegion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports